// extracted by mini-css-extract-plugin
module.exports = {"customInput":"index_customInput__3-flx","wrapperRemove":"index_wrapperRemove__ZcfTV","removeIcon":"index_removeIcon__1Qffs","actionBtn":"index_actionBtn__33TyF"};